import Dexie from 'dexie';

export const db = new Dexie('zarpChats');

// Define schema
db.version(2).stores({
  chats: '++id, chatId, type, images, content, role, model, firstResponseTime, timestamp, heading, character',
  chatMetadata: 'chatId, heading, character, lastUpdated' // Store for chat metadata
});

// Migration function to populate chatMetadata from existing chats
db.version(2).upgrade(async tx => {
  console.log("Running database migration...");
  const chats = await tx.table('chats').toArray();
  const metadata = new Map();
  
  // Get latest message for each chat
  chats.forEach(chat => {
    const existing = metadata.get(chat.chatId);
    if (!existing || chat.timestamp > existing.lastUpdated) {
      metadata.set(chat.chatId, {
        chatId: chat.chatId,
        heading: chat.heading || chat.content,
        character: chat.character,
        lastUpdated: chat.timestamp
      });
    }
  });
  
  // Add metadata to new store
  const metadataArray = [...metadata.values()];
  console.log("Adding metadata entries:", metadataArray);
  await tx.table('chatMetadata').bulkAdd(metadataArray);
});

// Helper function to update chat metadata
export const updateChatMetadata = async (message) => {
  console.log("Updating metadata for chat:", message.chatId);
  await db.chatMetadata.put({
    chatId: message.chatId,
    heading: message.heading || message.content,
    character: message.character,
    lastUpdated: message.timestamp || Date.now()
  });
};

// Update appendChat to also update metadata
export const appendChat = async (message) => {
  console.log("Appending chat message:", message);
  // For new chats, ensure we have metadata
  if (message.role === 'user') {
    await updateChatMetadata(message);
  }
  
  // Add the message
  await db.chats.add(message);
};

export const deleteChatsByChatId = async (chatId) => {
  await db.chats.where('chatId').equals(chatId).delete();
  await db.chatMetadata.where('chatId').equals(chatId).delete();
};

// delete individual message by id by changing content to "deleted"
export const deleteMessageById = async (id) => {
  await db.chats.where('id').equals(id).modify({ content: "deleted" });
};

export const exportChatById = async (chatId) => {
  try {
    const chatMessages = await db.chats
      .where('chatId')
      .equals(chatId)
      .toArray();

    let sorted = chatMessages.sort((a, b) => a.timestamp - b.timestamp);

    let parsed = sorted.map((s) => {
      return {
        role: s.role == "assistant" ? "Teme UNS AI" : s.role,
        message: s.content,
        timestamp: s.timestamp
      }
    });

    const chatData = JSON.stringify(parsed, null, 2);
    
    const blob = new Blob([chatData], { type: 'application/json' });
    const downloadLink = document.createElement('a');
    const url = URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = `zarp_chat_${chatId}_${new Date().toISOString().split(':')[0].replace(/:/g, '')}.json`;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);

    console.log(`Chat ${chatId} has been downloaded.`);
  } catch (error) {
    console.error(`Error exporting chat ${chatId}:`, error);
  }
};